import { render, staticRenderFns } from "./ProjectTime.vue?vue&type=template&id=1420b7e9&"
import script from "./ProjectTime.vue?vue&type=script&lang=ts&"
export * from "./ProjectTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports